import { Pencil } from "lucide-react";
import { type FC, type ReactElement } from "react";

import { cn } from "@/lib/utils";
import { commonIconProps20 } from "@/utils/constants";

import { CustomButton } from "../Button";
import DetailsTitle from "./DetailsTitle";

interface DetailsBlockProps {
  children: ReactElement;
  title?: string;
  titleAddon?: ReactElement;
  classes?: string;
  isEdit?: boolean;
  isActive?: boolean;
  setActive?: (a: boolean) => void;
}
const DetailsBlock: FC<DetailsBlockProps> = ({
  children,
  title,
  titleAddon,
  classes = "",
  isEdit = false,
  isActive = false,
  setActive,
}) => {
  return (
    <div
      className={cn(
        "relative flex flex-col gap-[21px] p-3 sm:p-[22px] border rounded-[8px]",
        isActive ? "border-gray-950 p-[21px] gap-[24px]" : "border-slate-200",
        classes
      )}
    >
      {(title || isEdit) && (
        <div className="flex justify-between">
          {title && <DetailsTitle title={title}>{titleAddon}</DetailsTitle>}
          {isEdit && (
            <CustomButton
              variant="icon"
              className="px-0! py-[5px]! h-fit"
              onClick={() => setActive?.(true)}
              data-testid="details-block-edit-button"
            >
              <Pencil {...commonIconProps20} />
            </CustomButton>
          )}
        </div>
      )}

      {children}
    </div>
  );
};

export default DetailsBlock;
